import { useSendSecureFormTokenRequest } from '../api/useSendSecureFormTokenRequest';
import { useCallback } from 'react';
export const useSendSecureFormToken = () => {
    const sendSecureFormTokenRequest = useSendSecureFormTokenRequest();
    return useCallback((vars) => sendSecureFormTokenRequest(vars).then(res => res.sendSecureFormToken), [sendSecureFormTokenRequest]);
};
